import decamelizeKeys from '../utils/decamelize-for-files';
import api from './index';
export default { create(data) { const path = '/api/internal/contact_form_messages'; return api({ method: 'post', url: path, data: decamelizeKeys({ contactFormMessage: data }) }); } };
